// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"map-module--wrapper--3_5Lx"};